import { render, staticRenderFns } from "./noVerification.vue?vue&type=template&id=31289958&scoped=true&"
import script from "./noVerification.vue?vue&type=script&lang=js&"
export * from "./noVerification.vue?vue&type=script&lang=js&"
import style0 from "./noVerification.vue?vue&type=style&index=0&id=31289958&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31289958",
  null
  
)

export default component.exports